import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";

countries.registerLocale(enLocale);

// Cache so we don't recreate Intl.DisplayNames on every call
const frenchRegionNames = new Intl.DisplayNames(["fr"], { type: "region" });

/**
 * Converts a backend country key (e.g. "tunisia", "Spain", "FRANCE")
 * into its French display name (e.g. "Tunisie", "Espagne", "France").
 * Falls back to a capitalized version of the key if unresolvable.
 */
export const formatCountryLabel = (key) => {
  if (!key) return key;

  const isoCode = countries.getAlpha2Code(key, "en");

  if (isoCode) {
    try {
      return frenchRegionNames.of(isoCode);
    } catch {
      // Intl.DisplayNames couldn't resolve it — fall through to fallback
      console.warn(`[formatCountryLabel] Could not resolve label for ISO code "${isoCode}" (from key "${key}")`);
    }
  } else {
    console.warn(`[formatCountryLabel] No ISO code match found for backend key "${key}" — using fallback label`);
  }

  // Fallback: just capitalize what the backend sent
  return key.charAt(0).toUpperCase() + key.slice(1);
};